import { type EventsDetailsPageProps } from 'hb-react/shared/apps/Events/startup/types';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import { EventDetailsPage as DetailsPageV1 } from './v1';
import { DetailsPage as DetailsPageV2 } from './v2';

export const DetailsPage = (props: EventsDetailsPageProps) => {
  const { flagEvImproveSoldOutEventsFo } = useFeatureFlag();

  if (flagEvImproveSoldOutEventsFo) {
    return <DetailsPageV2 {...props} />;
  }

  return <DetailsPageV1 {...props} />;
};
